import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(Stack)(
  ({ theme: { spacing, palette, colors } }) => ({
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: spacing(0.4, 2.4, 0.4, 0),
    '& .avatarButton': {
      padding: '0',
      marginLeft: spacing(0.8),
      '& .MuiAvatar-root': {
        backgroundColor: palette.common.white,
        color: palette.secondary.main,
        border: `${spacing(0.1)} solid ${palette.secondary.main}`,
        height: spacing(3.2),
        width: spacing(3.2),
      },
    },
    '& .logoutIcon': {
      marginLeft: spacing(0.8),
      color: colors.sideBarMenu,
    },
  })
);
